import { Component, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import * as dayjs from 'dayjs';
import { MenuCategory, MenuItem, MenuSection } from 'src/app/models/rich-data.model';
import { DataService } from 'src/app/services/data.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';

@Component({
  selector: 'app-ai-chat',
  templateUrl: './ai-chat.component.html',
  styleUrls: ['./ai-chat.component.scss']
})
export class AiChatComponent implements OnInit {

  @ViewChild('content') content: IonContent;

  buttons: MessageModel[] = [
    {
      name: 'Eating',
      msg: 'Show me the places that I can eat something',
      icon: 'restaurant-outline',
      reply: 'The places that you can eat something',
      key: ['restaurants']
    },
    {
      name: 'Drinking',
      msg: 'Show me the places that I can drink something',
      icon: 'beer-outline',
      reply: 'The places that you can drink something',
      key: ['bars', 'cafes']
    },
    {
      name: 'Services',
      msg: 'I need help',
      icon: 'bed-outline',
      reply: 'Here is our services.',
      key: ['housekeeping', 'amenities', 'room_services', 'front_office', 'issues', 'complaint']
    },
    {
      name: 'Places',
      msg: 'Show me places that I can explore',
      reply: 'We wish you have a good time when you exploring this places!',
      icon: 'map-outline',
      key: ['po_is', 'malls', 'tours']
    }
  ];

  messages: ChatModel[] = [
    {
      user: 'hotel',
      type: 'text',
      nick: null,
      data: null,
      msg: 'Welcome, how can I help you?'
    }
  ];

  fullPageSlider = {
    initialSlide: 0
  };

  canReserve = false;
  workingHoursDisplay = false;
  fullImage = false;

  days: string[] = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  images: string[] = [];

  constructor(
    public dataServ: DataService,
    public modalServ: ModalMakerService
  ) { }

  async ngOnInit() {
    if (!this.dataServ.rData) {
      await this.dataServ.getRichData();
      this.dataServ.removeDateRange(this.dataServ.baseData);
    }
  }

  async write(message: MessageModel) {

    const DATA: MenuSection[] = [];

    message.key.forEach((key) => {
      if (this.dataServ.rData[key] && this.dataServ.rData[key].show && this.dataServ.rData[key].menu_categories
        && this.dataServ.rData[key].menu_categories.length > 0) {
        DATA.push(this.dataServ.rData[key]);
      }
    });

    this.messages.push({
      user: 'user',
      type: 'text',
      nick: null,
      msg: message.msg,
      data: null
    });

    await this.scroll();

    this.messages.push({
      user: 'hotel',
      type: 'text',
      nick: null,
      msg: message.reply,
      data: DATA
    });

    await this.scroll();
  }

  async detail(item: MenuItem, section: MenuSection, category: MenuCategory) {
    this.canReserve = false;
    this.workingHoursDisplay = false;

    if (item && item.booking_system !== 'only timetable'
      && item.menu_item_books && item.menu_item_books.length > 0
      && item.menu_section_id !== 105 && (this.dataServ.rData.open_for_year
        || (dayjs(new Date()).diff(this.dataServ.rData.open_date) > 0
          && dayjs(new Date()).diff(this.dataServ.rData.close_date) < 0))) {
      {
        this.canReserve = true;
      }
    }

    if (item.menu_item_books) {
      this.workingHoursDisplay = true;

      item.menu_item_books.forEach(book => {
        if (book.menu_item_book_details) {
          book.menu_item_book_details.map(detail => {
            const UTC = dayjs(detail.start_time).utcOffset();
            detail.start_time = dayjs(detail.start_time).add(-UTC, 'minutes').toISOString();
            detail.end_time = dayjs(detail.end_time).add(-UTC, 'minutes').toISOString();
          });
        }
      });
    }

    this.messages.push({
      user: 'hotel',
      type: 'text',
      nick: item.name,
      msg: item.description,
      avatar: item.image_url,
      data: null,
      gallery: item.images && item.images.length > 0 ? item.images.map(img => img.url) : null
    });

    this.images = item.images && item.images.length > 0 ? item.images.map(img => img.url) : [];

    await this.scroll();



    if (this.workingHoursDisplay) {
      this.messages.push({
        user: 'hotel',
        nick: item.name,
        msg: ``,
        avatar: item.image_url,
        type: 'schedule',
        data: null,
        item
      });

      await this.scroll();
    }

    if (this.canReserve) {
      this.messages.push({
        user: 'hotel',
        nick: item.name,
        msg: ``,
        avatar: item.image_url,
        type: 'reservation',
        data: null,
        item,
        section,
        category
      });

      await this.scroll();
    }

  }

  reservation(msg: ChatModel) {
    this.dataServ.menuSection = msg.section;
    this.dataServ.menuCategory = msg.category;
    this.dataServ.menuItem = msg.item;

    this.modalServ.reservation();
  }

  scroll(): Promise<boolean> {
    return new Promise((resolve) => {
      setTimeout(() => {
        this.content.scrollToBottom(300);
        resolve(true);
      }, 500);
    });
  }
}

interface MessageModel {
  name: string;
  icon: string;
  msg: string;
  reply: string;
  key: string[];
}

interface ChatModel {
  user: string;
  type: 'text' | 'schedule' | 'reservation';
  msg: string;
  data: MenuSection[];
  nick: string;
  avatar?: string;
  item?: MenuItem;
  section?: MenuSection;
  category?: MenuCategory;
  gallery?: string[];
}
